var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	81924: {
		fallback: function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	10865: {
		fallback: function() { return Promise.all([__webpack_require__.e(4721), __webpack_require__.e(7884), __webpack_require__.e(6715), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	33224: {
		fallback: function() { return Promise.all([__webpack_require__.e(4721), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	59914: {
		fallback: function() { return Promise.all([__webpack_require__.e(7884), __webpack_require__.e(8122), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	38006: {
		fallback: function() { return Promise.all([__webpack_require__.e(8122), __webpack_require__.e(9965)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	44178: {
		fallback: function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	1995: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	13732: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	16141: {
		fallback: function() { return __webpack_require__.e(8037).then(function() { return function() { return __webpack_require__(48037); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	36764: {
		fallback: function() { return __webpack_require__.e(1816).then(function() { return function() { return __webpack_require__(41816); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	99247: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	8122: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	97316: {
		fallback: function() { return __webpack_require__.e(8133).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	44308: {
		fallback: function() { return __webpack_require__.e(2346).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	26932: {
		fallback: function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	71094: {
		fallback: function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	57167: {
		fallback: function() { return __webpack_require__.e(7281).then(function() { return function() { return __webpack_require__(67281); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ldp/common-contexts",
	},
	60031: {
		fallback: function() { return __webpack_require__.e(2932).then(function() { return function() { return __webpack_require__(2932); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@opentelemetry/api",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [81924,10865,33224,59914,38006,44178,1995,13732,16141,36764,1995,13732,99247,8122,97316,10865,44308,26932,71094,57167];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"93": [
		57167
	],
	"636": [
		97316,
		10865,
		44308,
		26932
	],
	"1094": [
		71094
	],
	"3343": [
		60031
	],
	"5527": [
		81924,
		10865,
		33224,
		59914,
		38006,
		44178,
		1995,
		13732,
		16141,
		36764
	],
	"8122": [
		8122
	],
	"8792": [
		1995,
		13732,
		99247,
		8122
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}